import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_ADMIN_TASK: (task) => ({ task }),
    API: {
      UPDATE_ADMIN_TASK: apiResourceActionCreator('task')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.put(`${API_ENDPOINT}/tasks}`, authToken, payload.task, actions.admin.api.updateAdminTask);

function* updateAdminTask(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'updateAdminTask',
  action: actions,
  sagas: updateAdminTask,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdatingTask: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isUpdatingTask: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isUpdatingTask: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateAdminTask.js